app.bind('default', function (context) {
    const $window = $(window);
    const $document = $(document);
    const $box = $('[js-scroll-box]', context);
    const $link = $('[js-scroll-top]', context);
    const $footer = $('[js-footer-bottom]', context);

    let delta = 85

    $box.css('margin-bottom', $footer.outerHeight() + delta);
    $window.on({
        scroll: function () {
            if ($document.scrollTop() > $window.height()) {
                $link.addClass('is-active');
            } else {
                $link.removeClass('is-active');
            }
        },
        resize: function () {
            $box.css('margin-bottom', $footer.outerHeight() + delta);
        }
    });
    $link.on('click', function () {
        $.scrollTo('body', 300);
    })
});
